import { connect } from 'react-redux';
import selectors from '../../rootSelectors';
import AudioSavingErrorView from './AudioSavingErrorView';
import { logUserOut } from '../user/userActions';
import { goTo } from '../navigation/navigationActions';
import { TRC_BOOK_START } from '../../constants/url';
import { clearAudioSavingError } from '../api/apiCallActions';
import { saveStudentRecording } from '../api/trcoActions';
import { blockScreen, unblockScreen } from '../screen/screenActions';
import {
    completeTRCBookResult,
    syncOfflineAudioForResult,
    cleanUpBook,
} from '../../trc/trcActions';
import { trackTroError } from '../../trc/trcReporting';
import { NoRecordingError } from '../recording/recordingError';

const mapStateToProps = state => ({
    statusCode:
        !selectors.getIsBackgroundRetryInProgress(state) &&
        selectors.getAudioSavingErrorStatus(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    isBenchmarkModeEnabled: selectors.getisBenchmarkModeEnabled(state),
});

const mapDispatchToProps = dispatch => ({
    logUserOut,
    onRetry: () => {
        dispatch(blockScreen());
        return dispatch(saveStudentRecording())
            .catch(error => {
                if (error instanceof NoRecordingError) {
                    return dispatch(syncOfflineAudioForResult());
                }
                throw error;
            })
            .then(() => dispatch(completeTRCBookResult()))
            .finally(() => {
                dispatch(unblockScreen());
            });
    },
    onRestart: () => {
        dispatch(clearAudioSavingError());
        dispatch(cleanUpBook());
        dispatch(goTo(TRC_BOOK_START));
    },
    onTroError: statusCode => dispatch(trackTroError(`Audio Saving Error: ${statusCode}`)),
});

const AudioSavingErrorContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AudioSavingErrorView);

export default AudioSavingErrorContainer;
